import React, { useRef, useState } from "react";
import { Box } from "@mui/material";

// มือถือ (xs): สไลด์แนวนอนด้วย CSS scroll-snap + จุดบอกตำแหน่ง
// sm ขึ้นไป: แสดงเป็น grid ตาม gridColumns
export default function SnapSlider({
  children,
  slideWidth = "min(78vw, 340px)",
  gridColumns = { sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
  gap = { xs: 2, md: 3 },
  dotColor = "#2e7d32",
  dotIdleColor = "rgba(46,125,50,0.3)",
}) {
  const ref = useRef(null);
  const [active, setActive] = useState(0);
  const slides = React.Children.toArray(children);

  // สไลด์ที่อยู่ใกล้กลางจอที่สุด = active
  const handleScroll = () => {
    const el = ref.current;
    if (!el) return;
    const center = el.scrollLeft + el.clientWidth / 2;
    let best = 0;
    let bestDist = Infinity;
    [...el.children].forEach((c, i) => {
      const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    if (best !== active) setActive(best);
  };

  const goTo = (i) => {
    const el = ref.current;
    const c = el?.children[i];
    if (c) el.scrollTo({ left: c.offsetLeft - (el.clientWidth - c.offsetWidth) / 2, behavior: "smooth" });
  };

  return (
    <Box sx={{ width: "100%", minWidth: 0 }}>
      <Box
        ref={ref}
        onScroll={handleScroll}
        sx={{
          display: { xs: "flex", sm: "grid" },
          gridTemplateColumns: gridColumns,
          gap,
          overflowX: { xs: "auto", sm: "visible" },
          scrollSnapType: { xs: "x mandatory", sm: "none" },
          // เว้นซ้าย-ขวาเท่ากัน = สไลด์แรก/สุดท้ายอยู่กึ่งกลางจอ (xs กว้างเต็มจอ)
          px: { xs: `calc((100vw - ${slideWidth}) / 2)`, sm: 0 },
          py: { xs: 1, sm: 0 },
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          WebkitOverflowScrolling: "touch",
        }}
      >
        {slides.map((child, i) => (
          <Box
            key={i}
            sx={{
              flex: { xs: `0 0 ${slideWidth}`, sm: "initial" },
              scrollSnapAlign: { xs: "center", sm: "none" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "transform 0.3s ease, opacity 0.3s ease",
              transform: { xs: i === active ? "scale(1)" : "scale(0.92)", sm: "none" },
              opacity: { xs: i === active ? 1 : 0.7, sm: 1 },
            }}
          >
            {child}
          </Box>
        ))}
      </Box>

      <Box sx={{ display: { xs: "flex", sm: "none" }, justifyContent: "center", gap: 0.75, mt: 1.5 }}>
        {slides.map((_, i) => (
          <Box
            key={i}
            component="button"
            type="button"
            aria-label={`slide ${i + 1}`}
            onClick={() => goTo(i)}
            sx={{
              width: i === active ? 22 : 8,
              height: 8,
              p: 0,
              border: 0,
              borderRadius: 999,
              cursor: "pointer",
              bgcolor: i === active ? dotColor : dotIdleColor,
              transition: "all 0.3s ease",
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
